<template>
	<div class='p-custom-select-container'>

		<!-- MULTIPLE SELECT -->
		<template v-if='multiple'>
			<p-multiselect
				:value='value'
				:options="options"
				:optionLabel="optionLabel"
				:dataKey='dataKey'
				
				:filter='filter'
				filterPlaceholder='Поиск...'
				emptyFilterMessage='Не найдено элементов'
				:disabled='disabled'
				@input='onInput'
			/>
		</template>

		<!-- SINGLE SELECT -->
		<template v-else>
			<p-dropdown
				:value='value'
				:options='options'
				:optionLabel='optionLabel'
				:dataKey='dataKey'
				
				showClear
				:filter='filter'
				emptyFilterMessage='Не найдено элементов'
				:disabled='disabled'
				appendTo='body'
				@input='onInput'
			/>
		</template>

		<p-spinner v-if='loading' stroke-width='6'/>

	</div>
</template>

<script>
	export default {
		name: 'CustomPSelect',

		props: {
			value: {
				type: null, /* null - любой тип */
				required: true
			},

			options: {
				type: Array,
				required: true,
				default: () => [],
			},

			optionLabel: {
				type: String,
				default: 'name',
			},

			dataKey: {
				type: String,
				default: 'id',
			},

			multiple: {
				type: Boolean,
				default: false
			},

			disabled: {
				type: Boolean,
				default: false
			},

			loading: {
				type: Boolean,
				default: false
			},

			filter: {
				type: Boolean,
				default: true
			}

		},

		methods: {
			onInput(value) {
				this.$emit('input', value);
			},
		}

	};
</script>

<style lang='scss' scoped>
	@import '@/style/constants.scss';

	.p-custom-select-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.p-progress-spinner {
		height: 24px;
		width: 24px;
	}

	.p-dropdown,
	.p-multiselect {
		width: 100%;
		// border: 1px solid #2E4E71;
		border-radius: 2px;
	}

	.p-dropdown::v-deep .p-dropdown-label,
	.p-multiselect::v-deep .p-multiselect-label {
		overflow: visible;
		white-space: normal;
	}

	.p-dropdown::v-deep .p-dropdown-label.p-placeholder,
	.p-multiselect::v-deep .p-multiselect-label.p-placeholder {
		color: $placeholder-color;
	}

	.p-dropdown::v-deep .p-dropdown-panel,
	.p-multiselect::v-deep .p-multiselect-panel {
		width: 100%;
	}

	.p-dropdown::v-deep .p-dropdown-items-wrapper,
	.p-multiselect::v-deep .p-multiselect-items-wrapper {
		width: 100%;
	}

	.p-dropdown::v-deep .p-dropdown-item,
	.p-multiselect::v-deep .p-multiselect-item {
		white-space: normal;
	}
</style>